<template>
  <DPHeader titlu="Activități extrașcolare CNLR"/>
  <div class="container">
    <div class="row">
      <div class="col-lg-3">
        <div class="mb-3 text-end" v-if="false">
          <div class="btn-group">
            <a href="#" class="btn btn-primary" :class="{active: sort_ascending}" @click="this.$store.commit('updateSortAscending' , true)">
              <i class="fas fa-sort-amount-up"></i>
              Oldest first
            </a>
            <a href="#" class="btn btn-primary" :class="{active: !sort_ascending}" @click="this.$store.commit('updateSortAscending' , false)">
              <i class="fas fa-sort-amount-down"></i>
              Newest first
            </a>
          </div>
        </div>

        <div class="mb-3">
          <h5>Categorii</h5>
          <div class="list-group mb-3">
              <a href @click.prevent="filter_categorie==C.titlu_lung?this.$store.commit('updateFilterCategorie', ``): this.$store.commit('updateFilterCategorie', C.titlu_lung)"  class="list-group-item" :class="{active: filter_categorie == C.titlu_lung}" v-for="C,I in categorii_activitati" :key="I">
                {{C.titlu_scurt}}
              </a>
          </div>
        </div>
        
        <div class="rounded border mb-3 p-2 text-center text-muted">
          <div class="h1">{{NumCards}}</div>
          <p>{{NumCards == 1?"activitate":"activități"}}</p>
        </div>
      </div>
      <div class="col">
        <CardList />
      </div>
    </div>
  </div>
</template>

<script>
import CardList from './CardList.vue'
import DPHeader from './DPHeader.vue'
import Vuex from "vuex"

export default {
  name: 'HomePage',
  components: {
    CardList,
    DPHeader
  },
  data(){
    return {
      order: {
        criteria: 'date',
        ascendent: false,
      },
      number_of_results: 0,
      countries: ['Croatia', 'Italia', 'North Macedonia', 'Romania', 'Slovakia', 'Turkey', 'Transnational'],
      categorii_activitati:[
        {
          titlu_lung: "Evenimente (zile internaționale, naționale, mondiale etc)",
          titlu_scurt: "Evenimente",
        },
        {
          titlu_lung: "Școala încrederii",
          titlu_scurt: "Școala încrederii",
        },
        {
          titlu_lung: "Alte activități",
          titlu_scurt: "Alte activități",
        }
      ],
    }
  },
  computed:{
    ...Vuex.mapState(['filter_type' , 'filter_categorie', 'sort_ascending']),
    ...Vuex.mapGetters(['NumCards']),
  },
}
</script>

<style lang="scss" scoped>

</style>
